<div class="image-container {{ column.param }}-column-display">
  <div #reference class="focus-container">
    <img *ngIf="value; else empty" [src]="value" class="image" />

    <ng-template #empty>
      <div class="empty-photo">empty</div>
    </ng-template>
  </div>
</div>
